import { Alert, Button, Stack, Typography } from '@mui/material'
import type { FC } from 'react'
import { useState } from 'react'

import DeEscalateSidebar from '@/components/Escalation/DeEscalateSidebar'
import useUser from '@/hooks/useUser'
import { Role } from '@/types/User'
import { hasRole } from '@/utils/role'

export interface Props {
  reason: string
  authorId: string
  fullName: string
  subjectId: string
  onApplicantUpdated: () => void
}

const Warning: FC<Props> = ({ reason, fullName, subjectId, onApplicantUpdated }) => {
  const { roles } = useUser()

  const [isDeEscalateSidebarOpen, setIsDeEscalateSidebarOpen] = useState<boolean>(false)

  return (
    <>
      <Alert severity="warning">
        <Stack spacing={1} alignItems="start">
          <Typography>
            This applicant has been escalated by {fullName}. Reason: {reason}
          </Typography>
          {hasRole(roles, [Role.supervisor, Role.admin]) && (
            <Button onClick={() => setIsDeEscalateSidebarOpen(true)}>De-escalate</Button>
          )}
        </Stack>
      </Alert>
      <DeEscalateSidebar
        isOpen={isDeEscalateSidebarOpen}
        onClose={() => setIsDeEscalateSidebarOpen(false)}
        subjectId={subjectId}
        onApplicantUpdated={onApplicantUpdated}
      />
    </>
  )
}

export default Warning
